<i18n>
{
  "de": {
    "nenaFeatureIntro": "Wenn Du möchtest, schau hier gerne mal rein!",
    "nenaFeatureOfferAccessToFollowers": "Folge Nena mitNdrin und erhalte kostenlosen Zugang zu diesem Beitrag.",
    "offerAccess": "bietet Dir Zugriff auf diesen Beitrag!",
    "offerAccessToFollowers": "Folge {nickname} und erhalte kostenlosen Zugriff auf diesen Post"
  },
  "en": {
    "nenaFeatureIntro": "If you like, have a look here!",
    "nenaFeatureOfferAccessToFollowers": "Follow Nena mitNdrin and get free access to this post.",
    "offerAccess": "offers you access to this item!",
    "offerAccessToFollowers": "Follow {nickname} to gain free access to this post"
  }
}
</i18n>

<template>
  <div class="pl-10 pr-10">
    <div
      v-if="!showLoginOnly"
      class="pt-30"
    >
      <h3
        v-if="placeholderFeatureActive"
        class="title is-3 has-text-centered"
      >
        {{ $t('nenaFeatureIntro') }}
      </h3>
      <h3
        v-else
        class="title is-3 has-text-centered"
      >
        {{ artist.nickname }} {{ $t('offerAccess', {
          nickname:
            artist.nickname
        }) }}
      </h3>
      <h5
        v-if="!placeholderFeatureActive"
        class="title is-5 has-text-centered"
      >
        Let's make it happen!
      </h5>
      <select-purchasable
        :post="user.singlePost"
        :item="itemData"
        :placeholderFeatureActive="placeholderFeatureActive"
        @selected="purchasableSelected"
      />
      <div
        v-if="user.singlePost.limitToFollowers && !artist.followed"
        class="pt-20"
      >
        <p v-if="placeholderFeatureActive">
          {{ $t('nenaFeatureOfferAccessToFollowers') }}
        </p>
        <p v-else>
          {{ $t('offerAccessToFollowers', { nickname: artist.nickname }) }}
        </p>
        <followButton
          :user="user"
          :fullWidth="false"
          :withIcon="false"
          :singlePost="true"
          class="mt-5"
        />
      </div>
    </div>
    <div
      v-if="showLoginOnly && !isAuthenticated"
      class="pt-30"
    >
      <socialLogin
        :params="{
          isWizard: true,
          onPost: true,
          returnRouteObject: {
            route: {
              name: `id-post-slug-postId___${$i18n.locale}`,
              params: {
                id: artist.urlAlias,
                postId: user.singlePost.id,
                slug: urlSlug(user.singlePost.title),
                type: selectedPurchasable ? selectedPurchasable.type : null,
                item: selectedPurchasable ? selectedPurchasable.item._id : null
              },
              query: {
                refresh: true
              }
            },
            locales: $root.$i18n['locales'],
            locale: $i18n.locale
          }
        }"
        @cancelled="emitCancelled"
        @registration="setSocialRegistration"
        @logged="loggedIn"
      />
      <div v-if="!socialRegistration">
        <div
          class="is-divider"
          :data-content="$t('or')"
        />
        <login
          :params="{
            isWizard: true,
            onPost: true,
            returnRouteObject: {
              route: {
                name: `id-post-slug-postId___${$i18n.locale}`,
                params: {
                  id: artist.urlAlias,
                  postId: user.singlePost.id,
                  slug: urlSlug(user.singlePost.title),
                  type: selectedPurchasable ? selectedPurchasable.type : null,
                  item: selectedPurchasable ? selectedPurchasable.item._id : null
                },
                query: {
                  refresh: true
                }
              },
              locales: $root.$i18n['locales'],
              locale: $i18n.locale
            }
          }"
          @logged="loggedIn"
          @viewChanged="loginViewChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import socialLogin from '~/components/social-login'
import login from '~/components/login'
import selectPurchasable from '~/components/wizard-select-purchasable'
import followButton from '~/components/follow-button'

export default {
  props: ['post', 'item', 'showLoginOnly'],
  components: {
    login, socialLogin, selectPurchasable, followButton
  },
  data() {
    return {
      loginViewTitle: 'Login',
      socialRegistration: false,
      selectedPurchasable: null
    }
  },

  computed: {
    itemData() {
      if (this.$route.params.type && this.$route.params.item) {
        return {
          itemType: this.$route.params.type,
          itemId: this.$route.params.item
        }
      }
      return this.item
    },
    accessGranted() {
      return !this.post.locked || this.user.id === this.post.user
    },

    placeholderFeatureActive() {
      return ['nena', 'test', 'uscreen-account', 'hakuna-mipaka'].includes(this.artist.urlAlias)
    },
    ...mapState(['user', 'artist', 'isAuthenticated'])
  },

  mounted() {
    this.$root.$on('showGlobalFollowerModal', this.emitCancelled)
  },
  beforeDestroy() {
    this.$root.$off('showGlobalFollowerModal', this.emitCancelled)
  },

  methods: {
    ...mapActions(['getSinglePost']),
    purchasableSelected(purchasable) {
      this.selectedPurchasable = purchasable
      if (!this.accessGranted) {
        this.loggedIn()
      }
    },

    async loggedIn() {
      if (this.accessGranted) {
        return
      }

      // reload post after login
      const { post } = await this.getSinglePost({
        urlAlias: this.artist.urlAlias,
        postId: this.post._id,
        urlSlug: this.urlSlug(this.post.title)
      })

      if (post.locked) {
        this.gotoCheckout()
      }
    },
    gotoCheckout() {
      if (this.selectedPurchasable) {
        const url = this.checkoutUrl(this.selectedPurchasable.item._id)
        window.location.assign(url)
      }
    },
    loginViewChanged(title) {
      this.loginViewTitle = title
    },
    setSocialRegistration(value) {
      this.socialRegistration = value
    },
    emitCancelled() {
      this.$emit('cancelled')
    }
  }
}
</script>

<style lang="scss">
.wizard-tab-content {
  margin-bottom: 50px;
}

.wizard-navigation {
  .wizard-nav-pills {
    .active {
      .checked {
        background-color: var(--primary-color) !important;
      }
    }
  }
}
</style>
